import type { ApiRequestError } from '@/api/client'

/**
 * Plain-language reasons for the refusals admin-api's cleaning-job validation
 * gives, keyed by the `error` text it sends. The 400 body carries no error
 * code, so the text is the only stable handle there is.
 */
const REFUSALS: Record<string, string> = {
  'scheduled_at cannot be before checkout for a reservation-sourced job':
    "A cleaning can't be moved to before the guests check out.",
  'scheduled_at cannot be more than a day before the block ends':
    "A cleaning can't be moved to more than a day before the block ends.",
}

/**
 * The toast text for a cleaning action that failed.
 *
 * A refusal admin-api explained gets its plain reason. Anything else -
 * including a 400 this does not know - gets one generic line, never the raw
 * status line, JSON, field names or request id the client error message holds.
 */
export function cleaningActionErrorMessage(error: Error): string {
  const body = (error as ApiRequestError).body
  const reason =
    body && typeof body === 'object' && 'error' in body ? (body as { error: unknown }).error : null
  if (typeof reason === 'string' && REFUSALS[reason]) return REFUSALS[reason]
  return 'Something went wrong. Try again in a moment.'
}
